export const OVERALL_SCORE_DIMENSION_DEFINITION_ID = "69f23a38656b93ad60e4725c";

export const OVERALL_SCORE_MIN = 0;
export const OVERALL_SCORE_MAX = 100;

/** Inclusive score bands on the 0–100 quality scale (matches agent performance dashboard). */
export const CALL_QUALITY_SCORE_THRESHOLDS = {
    yellowMin: 60,
    greenMin: 80,
} as const;

export type CallDimensionFilters = {
    minValue?: number;
    maxValue?: number;
};

export type CallOverallScoreBounds = {
    overallScoreMin?: number;
    overallScoreMax?: number;
};

export const normalizeOverallScoreBounds = (
    overallScoreMin?: number,
    overallScoreMax?: number
): CallOverallScoreBounds => {
    if (overallScoreMin != null && overallScoreMax != null && overallScoreMin > overallScoreMax) {
        return {
            overallScoreMin: overallScoreMax,
            overallScoreMax: overallScoreMin,
        };
    }

    return { overallScoreMin, overallScoreMax };
};

export const resolveOverallScoreDimensionFilters = (
    overallScoreMin?: number,
    overallScoreMax?: number
): CallDimensionFilters | undefined => {
    const normalized = normalizeOverallScoreBounds(overallScoreMin, overallScoreMax);
    const hasMin = normalized.overallScoreMin != null;
    const hasMax = normalized.overallScoreMax != null;

    if (!hasMin && !hasMax) {
        return undefined;
    }

    return {
        ...(hasMin ? { minValue: normalized.overallScoreMin } : {}),
        ...(hasMax ? { maxValue: normalized.overallScoreMax } : {}),
    };
};
